// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const StatusProg75Icon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <path fill="currentColor" d="M12 3a9 9 0 1 1-9 9h9z" />
  </svg>,
  "StatusProg75",
);
export default StatusProg75Icon;
